export default {
  SELECT_SEGMENT: 'routeCreation/SELECT_SEGMENT',
  DESELECT_SEGMENT: 'routeCreation/DESELECT_SEGMENT',
  SET_CREATED_ROUTE_ID: 'routeCreation/SET_CREATED_ROUTE_ID',
  CLEAR_CREATE_ROUTE: 'routeCreation/CLEAR_CREATE_ROUTE',
};



// WEBPACK FOOTER //
// ./src/state/ducks/routeCreation/types.js